const BASE_URL = (process.env.REACT_APP_API_ROOT_BUREAU || process.env.REACT_APP_API_ROOT_DEFAULT) + '/plugins/bureau/';

export const urls = {
    bureau_details: BASE_URL + ':id/',
}